// ============================================================================
// French UI Copy — FULL SSOT (1:1 translation of en.ts)
// Texte uniquement — PAS de logique, PAS d’URLs, PAS de React
// ============================================================================

export const fr = {
  meta: {
    lang: 'fr',
    langFull: 'fr-FR',
    dir: 'ltr' as const,
    name: 'Français',
  },

  // ─────────────────────────────────────────────────────────────
  // WORDS
  // ─────────────────────────────────────────────────────────────

  words: {
    dj: {
      he: `DJ`,
      he_alt: `DJ`,
      he_plain: `DJ`,
      en: `DJ`,
    },
    music: 'Musique',

    mc: `DJ`,

    events: {
      wedding: { one: `Mariage`, many: `Mariages`, to: `pour un mariage` },
      henna: { one: `Henné`, many: `Henné`, to: `pour un henné` },
      bar_bat: {
        one: `Bar/Bat Mitsva`,
        many: `Bar/Bat Mitsvas`,
        to: `pour une Bar/Bat Mitsva`,
      },
      generic: { one: `Événement`, many: `Événements`, to: `pour un événement` },
    },

    albums: {
      forum: `Forum`,
      articles: `Articles`,
      recommendations: `Avis`,
      bars: `Bars`,
      flyers: `Flyers`,
    },

    phrases: {
      music_for_events: `musique pour événements`,
      company_or_private: `entreprise / privé`,
    },
  },

  business: {
    name: 'DJ ELIOR MOR — Musique pour événements',

    address: {
      street: 'Mivtsa Yoav 16',
      city: 'Be’er Sheva',
      postal: '8445914',
      country: 'IL',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // BRAND
  // ─────────────────────────────────────────────────────────────
  brand: {
    firstName: `ELIOR`,
    short: `ELIOR MOR`,
    title: `DJ ELIOR MOR`,
  },

  metaDescription: {
    wedding:
      'Plus de 15 ans d’expérience en mariages : bande-son personnalisée, excellente lecture du public, mix précis et fusion de styles, piste de danse pleine toute la nuit — DJ mariage professionnel',

    henna:
      'Plus de 15 ans d’expérience en henné : tradition mêlée à des rythmes modernes, ambiance colorée et piste de danse pleine — DJ henné professionnel',

    barBat:
      'Plus de 15 ans d’expérience en Bar/Bat Mitsva : entrée émouvante, musique pour adolescents et adultes, piste pleine du début à la fin — DJ professionnel',

    generic:
      'Plus de 15 ans d’expérience événementielle : planification musicale, lecture du public et fusion des styles, piste de danse pleine toute la soirée — DJ événement professionnel',
  },

  // ─────────────────────────────────────────────────────────────
  // HOME
  // ─────────────────────────────────────────────────────────────

  home: {
    title: `Musique pour événements | DJ ELIOR MOR`,

    description:
      `ELIOR MOR — DJ avec plus de 15 ans d’expérience dans les mariages, cérémonies de henné, Bar/Bat Mitsvas et événements. ` +
      `Expert en lecture du public, fusion des styles et mix fluides qui maintiennent la piste de danse pleine et créent une expérience musicale inoubliable`,

    heroTitle: `ELIOR MOR — Musique pour événements`,

    sections: {
      section1Lines: (
        eventOne: string,
        mcLabel: string,
        brandTitle: string
      ) => [
        `Plus de 15 ans à créer des ${eventOne}s parfaits`,
        'Musique précise et excellente lecture du public',
        'Son professionnel et mix fluides',
        `${eventOne} avec une ambiance joyeuse et énergique`,
        `Playlist adaptée exactement à votre ${eventOne}`,
        'Une expérience musicale inoubliable',
        `${brandTitle} — ${mcLabel} pour le ${eventOne} parfait`,
      ],

      section2DescriptionSuffix: (eventOne: string) =>
        `pour que chaque ${eventOne} devienne une expérience inoubliable dont les invités parleront longtemps après la fin`,

      section2AdditionalSuffix: '',

      section5SubtitleDesktop: (
        weddingOne: string,
        hennaOne: string,
        barBatOne: string,
        genericOne: string
      ) =>
        `Que ce soit un ${weddingOne}, un ${hennaOne}, une ${barBatOne} ou tout autre ${genericOne} — j’adapte la musique à votre public et à l’ambiance souhaitée. Grâce à un timing précis, une excellente lecture du public et une fusion intelligente des styles, la soirée se déroule naturellement avec une énergie élevée et une piste pleine`,

      section5SubtitleMobile: (
        weddingMany: string,
        hennaMany: string,
        barBatOne: string,
        genericMany: string,
        genericOne: string
      ) =>
        `${weddingMany}, ${hennaMany}, ${barBatOne} et événements professionnels — j’adapte la musique à votre public et garde la piste pleine jusqu’à la fin de ${genericOne}.`,

      section6Title: (brandTitle: string) =>
        `Avis sur ${brandTitle}`,

      section6Subtitle: (genericOne: string) =>
        `Que disent les clients de l’expérience sur la piste de danse ? Avis réels sur la musique, l’énergie et l’accompagnement du premier appel jusqu’à la fin de ${genericOne}`,
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 1 — OPEN
  // ─────────────────────────────────────────────────────────────

  section1: {
    targetPageLines: {
      base: [
        'Plus de 15 ans d’expérience dans tous types d’événements',
        'Musique adaptée à l’énergie de votre public',
        'Excellente lecture du public et ambiance irrésistible',
        'Piste de danse pleine jusqu’au petit matin',
      ],

      wedding: [
        'Plus de 15 ans d’expérience en mariages',
        'Musique adaptée à chaque moment du mariage',
        'Bande-son personnalisée',
        'Mix fluides et excellente lecture du public',
        'Planification musicale complète et accompagnement professionnel',
        'Un mariage dont les invités parleront longtemps',
      ],

      henna: [
        'Célébration de henné émotive avec ambiance authentique',
        'Ambiance colorée et joyeuse',
        'Mélange parfait de tradition et de modernité',
        'Rythmes qui entraînent toute la famille',
        'Playlist adaptée à votre henné',
        'Cérémonie électrisante pleine d’émotion',
      ],

      bar_bat: [
        'Plus de 15 ans d’expérience en Bar/Bat Mitsva',
        'Entrée mémorable',
        'Piste pleine du premier morceau au dernier',
        'Hits actuels pour adolescents et adultes',
        'Ambiance familiale joyeuse',
        'Expérience musicale mémorable',
      ],

      event: [
        'Plus de 15 ans d’expérience événementielle',
        'Musique précise et excellente lecture du public',
        'Son professionnel et mix fluides',
        'Ambiance énergique et festive',
        'Playlist adaptée à votre événement',
        'Une expérience musicale inoubliable',
      ],
    },

    hub: {
      city: {
        descriptionLines: (
          keyword: string,
          cityBet: string,
          brandTitle: string
        ) => [
          'Plus de 15 ans d’expérience qui parlent d’eux-mêmes',
          'Musique adaptée à chaque type de public',
          'Capacité à lire la piste et jouer le bon morceau',
          'Ambiance joyeuse du début à la fin de l’événement',
          `${brandTitle} — ${keyword}${cityBet}`,
        ],

        extraHeadings: (keyword: string, cityBet: string) => [
          `Comment choisir ${keyword}${cityBet} correctement`,
          `Types d’événements populaires${cityBet}`,
        ],
      },

      region: {
        descriptionLines: (
          keyword: string,
          regionBet: string,
          brandTitle: string
        ) => [
          'Plus de 15 ans d’expérience qui parlent d’eux-mêmes',
          'Musique variée adaptée à tous les publics',
          'Piste pleine d’énergie et de joie',
          'Ambiance festive toute la soirée',
          `${brandTitle} — ${keyword}${regionBet}`,
        ],

        extraHeadings: (keyword: string, regionBet: string) => [
          `Comment choisir ${keyword}${regionBet}`,
          `Villes principales${regionBet} pour commencer votre recherche`,
        ],
      },

      home: {
        section1Lines: (
          eventOne: string,
          mcLabel: string,
          brandTitle: string
        ) => [
          `Plus de 15 ans d’expérience pour garantir un ${eventOne} parfait`,
          'Musique précise et excellente lecture du public',
          'Son professionnel et mix fluides',
          `${eventOne} avec une ambiance joyeuse et énergique`,
          `Playlist adaptée exactement à votre ${eventOne}`,
          'Une expérience musicale inoubliable',
          `${brandTitle} — ${mcLabel} pour le ${eventOne} parfait`,
        ],
      },
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 2 — ABOUT
  // ─────────────────────────────────────────────────────────────

  section2: {
    title: 'Mon histoire',
    description:
      `Avec plus de 15 ans derrière les platines, dont une décennie en tant que DJ résident au Forum — je suis ELIOR MOR, apportant l’énergie idéale, une lecture experte du public et une musique qui maintient la piste vivante du premier au dernier morceau.`,

    additionalText:
      'Pour moi, chaque événement est une opportunité de créer des moments inoubliables. Je lis le public, mélange les styles et surprends avec des morceaux oubliés — transformant votre événement en une expérience unique',

    imageAltPortrait: `ELIOR MOR au DJ booth`,
    imageAltHorizontal: `ELIOR MOR — DJ qui sait enflammer la fête`,

    targetAdditionalByService: {
      wedding:
        'Un mariage est une histoire d’amour racontée à travers la musique. Je commence par vous connaître vraiment — qui vous êtes, ce que vous aimez et comment vous imaginez votre mariage. Ensuite, nous créons une bande-son personnalisée et construisons chaque moment ensemble',

      henna:
        'Chaque henné est une fête colorée que je construis dès le premier instant. Mon objectif est simple — ambiance joyeuse, énergie et piste pleine. Je mélange tradition et modernité pour créer une énergie irrésistible',

      bar_bat:
        'Chaque Bar/Bat Mitsva est une opportunité de créer des moments spéciaux qui rassemblent tout le monde. Mon objectif est une fête naturelle pour les jeunes et agréable pour les adultes',

      event:
        'Chaque événement est une opportunité de créer une expérience musicale précise adaptée au public et à l’occasion, avec une énergie constante toute la nuit',
    },

    targetAdditionalSuffixByService: {
      wedding:
        'J’apporte une touche personnelle et une précision ressentie à chaque moment',

      henna:
        'J’ajoute une touche unique qui transforme votre henné en fête mémorable',

      bar_bat:
        'Je construis une identité musicale adaptée à votre famille',

      event:
        'J’ajuste la musique pour donner un caractère unique à chaque événement',
    },

    fallbackSuffix:
      'Ainsi votre événement bénéficie d’une ambiance parfaitement adaptée à votre public',

    targetDescription: (
      baseDescription: string,
      djKeyword: string,
      cityBet: string
    ) =>
      `${baseDescription} Je suis ${djKeyword}${cityBet}, avec une excellente connaissance du public et des lieux locaux`,

    targetAdditionalText: (
      base: string,
      cityBet: string,
      suffix: string
    ) => `${base} ${cityBet} ${suffix}`.replace(/\s+/g, ' ').trim(),
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 3 — GALLERY
  // ─────────────────────────────────────────────────────────────

  section3: {
    title: 'Laissez les photos parler',
    fallbackText: 'Sélectionnez un album pour voir plus de détails',
    albumsError: 'Impossible de charger les albums. Veuillez réessayer plus tard.',
    filesError: 'Erreur lors du chargement des fichiers.',
    loading: 'Chargement de la galerie…',

    galleryHeadings: {
      wedding: (keyword: string, cityBet: string) => [
        `Photos de mariage${cityBet} — cérémonie, première danse et piste`,
        `Moments de mariage${cityBet} — énergie sur la piste`,
        `Couples heureux et sets explosifs — mariages${cityBet}`,
      ],

      henna: (_keyword: string, cityBet: string) => [
        `Galerie henné${cityBet} — couleurs, rythmes et énergie`,
        `Tradition et joie — célébrations de henné${cityBet}`,
        `Tambours et énergie — vrais moments de henné${cityBet}`,
      ],

      bar_bat: (_keyword: string, cityBet: string) => [
        `Bar/Bat Mitsva${cityBet} — entrée, piste et ambiance`,
        `Jeunes et familles sur la piste — Bar/Bat Mitsva${cityBet}`,
        `Moments forts — Bar/Bat Mitsva${cityBet}`,
      ],

      event: (_keyword: string, cityBet: string) => [
        `Moments d’événements${cityBet} — piste pleine`,
        `Style musical et énergie — événements${cityBet}`,
        `Galerie d’événements${cityBet} — moments inoubliables`,
      ],
    },

    albumDescriptions: {
      weddings:
        'Photos de vrais mariages — cérémonie, première danse et piste en feu',

      hennas:
        'Couleurs, tambours et énergie — hennés pleins de joie',

      barBat:
        'Moments forts de Bar/Bat Mitsva — entrée et piste pleine',

      forum:
        'Sets électrisants du club Forum à Be’er Sheva',

      articles:
        'Articles, interviews et couverture médiatique',

      recommendations:
        'Avis réels de clients après des soirées inoubliables',

      bars:
        'Sets dans des bars à travers le pays',

      flyers:
        'Collection de flyers d’événements et clubs',
    },

    albumTexts: {
      weddings:
        'Photos de vrais mariages — cérémonie, première danse et piste en feu',

      hennas:
        'Couleurs, tambours et énergie — hennés pleins de joie',

      barBat:
        'Moments forts de Bar/Bat Mitsva — entrée et piste pleine',

      forum:
        'Sets électrisants du club Forum à Be’er Sheva',

      articles:
        'Articles, interviews et couverture médiatique',

      recommendations:
        'Avis réels de clients après des soirées inoubliables',

      bars:
        'Sets dans des bars à travers le pays',

      flyers:
        'Collection de flyers d’événements et clubs',
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 4 — CONTACT / CTA
  // ─────────────────────────────────────────────────────────────

  section4: {
    title: 'Améliorez votre événement',

    description:
      'Vous cherchez un DJ pour votre événement ?\nIci vous trouverez la combinaison parfaite entre expérience, énergie et musique',

    groupTitles: {
      contact: 'Contact',
      events: 'Types d’événements',
      services: 'Services supplémentaires',
    },

    eventsIntro: {
      default: `Musique adaptée à tout type d’événement, privé ou professionnel`,

      wedding: (keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `${keyword}${loc} — de la cérémonie à la soirée, une musique adaptée à vous et à vos invités`;
      },

      henna: (keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `${keyword}${loc} — rythmes traditionnels mêlés à des sons modernes pour une célébration familiale colorée`;
      },

      bar_bat: (keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `${keyword}${loc} — hits actuels et classiques intemporels que tout le monde apprécie`;
      },

      event: (_keyword: string, _cityBet: string) =>
        `Musique personnalisée pour tout type d’événement, privé ou professionnel`,
    },

    servicesIntro: {
      wedding: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options mariage${loc} : éclairage, son professionnel et animations.`;
      },

      henna: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options henné${loc} : percussionnistes, éclairage chaleureux et animations`;
      },

      bar_bat: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options Bar/Bat Mitsva${loc} : éclairage, son de qualité et animations`;
      },

      event: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options événement${loc} : éclairage, son et animations adaptées`;
      },
    },

    eventsTexts: {
      wedding: (cityBet: string) =>
        `DJ mariage${cityBet} — musique parfaitement adaptée aux mariés et invités`,

      henna: (cityBet: string) =>
        `DJ henné${cityBet} — tradition authentique et rythmes modernes`,

      bar_bat: (cityBet: string) =>
        `DJ Bar/Bat Mitsva${cityBet} — hits pour toutes les générations`,

      event: (cityBet: string) =>
        `DJ événement${cityBet} — privé ou professionnel, adapté à tous les styles`,
    },

    groupTitlesSeo: {
      wedding: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Autres types d’événements${loc}`,
          services: `Services complémentaires mariage${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },

      henna: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Autres événements${loc}`,
          services: `Services complémentaires henné${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },

      bar_bat: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Types d’événements populaires${loc}`,
          services: `Options Bar/Bat Mitsva${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },

      event: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Types d’événements couverts${loc}`,
          services: `Services complémentaires événement${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },
    },

    contactSeo: {
      phone: `Appelez-moi — je serai ravi de répondre à vos questions.`,
      whatsapp: `Envoyez un message WhatsApp — je vous répondrai rapidement.`,
      email: `Vous pouvez aussi envoyer un email — réponse rapide.`,
      instagram: `Découvrez Instagram — vidéos et photos en direct.`,
      facebook: `Sur Facebook — avis et moments réels d’événements.`,
      navigate: `Accès facile — cliquez pour ouvrir Google Maps.`,
    },

    contactButtons: {
      phone: 'Appeler',
      whatsapp: 'WhatsApp',
      email: 'Email',
      instagram: 'Instagram',
      facebook: 'Facebook',
      navigate: 'Itinéraire',
    },

    prefills: {
      wedding:
        'Bonjour Elior,\nJe souhaiterais recevoir des informations pour un DJ de mariage.',
      henna:
        'Bonjour Elior,\nJe suis intéressé par un DJ pour un henné.',
      barBat:
        'Bonjour,\nJe cherche un DJ pour une Bar/Bat Mitsva — pouvez-vous m’envoyer des détails ?',
      generic:
        'Bonjour,\nJe recherche un DJ pour un événement privé/professionnel.',
    },

    blockCopy: {
      withCity: (
        keyword: string,
        cityName: string,
        firstName: string
      ) => ({
        description:
          `Vous cherchez ${keyword} à ${cityName} ?\nIci vous trouverez la combinaison parfaite entre expérience, énergie et musique`,

        whatsappPrefill:
          `Bonjour ${firstName}, je suis intéressé par ${keyword} à ${cityName}`,

        linksHeading:
          `Pages liées pour ${keyword} à ${cityName}`,
      }),

      withoutCity: (
        keyword: string,
        eventName: string,
        firstName: string
      ) => ({
        description:
          `Vous cherchez un DJ pour votre ${eventName} ?\nIci vous trouverez la combinaison parfaite entre expérience, énergie et musique`,

        whatsappPrefill:
          `Bonjour ${firstName}, je suis intéressé par un DJ pour mon ${eventName}`,

        linksHeading:
          `Pages liées pour DJ`,
      }),
    },

    services: {
      sound: {
        label: 'Sonorisation',
        description: 'Son professionnel — clair et puissant dans tout espace.',
      },
      light: {
        label: 'Éclairage',
        description: 'Éclairage dynamique — transforme la piste de danse.',
      },
      attractions: {
        label: 'Animations',
        description: 'Effets spéciaux — confettis, fumée lourde, ballons et plus.',
      },
      recording: {
        label: 'Enregistrement',
        description: 'Captation — première danse, discours ou moments spéciaux.',
      },
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — FAQ INTRO
  // ─────────────────────────────────────────────────────────────

  section5: {
    title: 'Infos',
    linksHeading: 'Pages recommandées',
    subtitle:
      'Réponses aux questions fréquentes sur la musique, la planification et votre événement.',
    moreLink: 'Voir plus de questions',

    headingsSeo: {
      wedding: (keyword: string, cityBet: string) => [
        `Planification musicale mariage${cityBet} du premier appel à la dernière chanson.`,
        `Musique de réception élégante.`,
        `Accompagnement complet de la cérémonie.`,
        `Entrées marié/mariée et moment du verre.`,
        `Transition fluide vers la danse.`,
        `Danse lente personnalisée.`,
        `Styles musicaux adaptés à chaque moment.`,
        `${keyword}${cityBet} qui vous accompagne jusqu’à la fin.`,
        `Piste de danse pleine d’énergie.`,
      ],

      henna: (keyword: string, cityBet: string) => [
        `Planification henné${cityBet} selon les traditions.`,
        `Ambiance joyeuse et colorée.`,
        `Entrée avec tambours.`,
        `Musique traditionnelle.`,
        `Moments clés du henné.`,
        `Musique pour échanges et cercles.`,
        `Mélange tradition/moderne.`,
        `${keyword}${cityBet} avec énergie authentique.`,
      ],

      bar_bat: (keyword: string, cityBet: string) => [
        `Planification Bar/Bat Mitsva${cityBet}.`,
        `Musique d’accueil.`,
        `Entrée personnalisée.`,
        `Musique pour discours.`,
        `Sets dynamiques.`,
        `Musique équilibrée.`,
        `Moments interactifs.`,
        `${keyword}${cityBet} qui garde la piste pleine.`,
      ],

      event: (
        keyword: string,
        cityBet: string,
        hasCity: boolean
      ) => {
        if (!hasCity) {
          return [
            `Chaque événement commence par comprendre le public.`,
            `Planification musicale complète.`,
            `Transitions naturelles.`,
            `${keyword} pour une soirée mémorable.`,
          ];
        }

        return [
          `Planification événement${cityBet}.`,
          `Musique d’accueil.`,
          `Transitions vers la danse.`,
          `${keyword}${cityBet} qui accompagne toute la soirée.`,
        ];
      },
    },

    eventTypeDescription: {
      wedding: {
        mobile: (_city: string, cityBet: string) =>
          `La musique de votre mariage${cityBet} est conçue selon votre vision — de la réception à la fête.`,

        desktop: (_city: string, cityBet: string) =>
          `Je crée une bande-son personnalisée pour votre mariage${cityBet}, de la cérémonie à la fête.`,
      },

      event: {
        mobile: (_city: string, cityBet: string) =>
          `Chaque événement${cityBet} est adapté au public.`,

        desktop: (_city: string, cityBet: string) =>
          `J’adapte la musique et le son pour chaque événement${cityBet}.`,
      },

      bar_bat: {
        mobile: (_city: string, cityBet: string) =>
          `Bar/Bat Mitsva${cityBet} — hits jeunes + classiques.`,

        desktop: (_city: string, cityBet: string) =>
          `Mix parfait entre hits modernes et classiques pour ${cityBet}.`,
      },

      henna: {
        mobile: (_city: string, cityBet: string) =>
          `Henné${cityBet} — énergie, tradition et fête.`,

        desktop: (_city: string, cityBet: string) =>
          `Tradition et énergie moderne pour un henné${cityBet}.`,
      },
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 6 — REVIEWS
  // ─────────────────────────────────────────────────────────────

  section6: {
    title: 'Avis & recommandations',

    subtitle:
      'Ce que disent les clients sur la piste, l’énergie et le service',

    aggregateText: 'Basé sur de vrais avis',

    readMore: 'Voir tous les avis',

    linkText: 'Vers la page complète',

    defaults: {
      title: (brandTitle: string) =>
        `Avis et recommandations pour ${brandTitle}`,

      subtitle: (
        brandShort: string,
        keyword: string,
        cityBet: string
      ) =>
        `Que disent les clients de ${brandShort} ?\nAvis réels sur ${keyword}${cityBet} — énergie, ambiance et service.`,
    },

    reviewsCount: (count: number) =>
      `Basé sur ${count} avis`,
  },

  misc: {
    professional: 'Professionnel',
    recommended: 'Recommandé',
  },

  // ─────────────────────────────────────────────────────────────
  // FOOTER
  // ─────────────────────────────────────────────────────────────

  footer: {
    copyright: (year: number) =>
      `© ${year} DJ ELIOR MOR — Tous droits réservés`,
    recommendedPages: 'Pages recommandées',
    accessibilityStatement: 'Déclaration d’accessibilité',
  },

  planning: {
    readMoreLabel: 'Guide complet',
    previousLabel: 'Précédent',
    nextLabel: 'Suivant',
    backHomeLabel: 'Retour',
    articleEyebrow: (service: string) => `${service} - guide de planification`,
    contactTitle: 'Vous voulez bien planifier la musique ?',
    contactButtonLabel: 'Contactez-moi',
    whatsappLabel: 'WhatsApp',
    phoneLabel: 'Appel',
    parentLinkLabel: (serviceLabel: string) => `Page ${serviceLabel}`,
    parentContext: (articleTitle: string, serviceLabel: string) => ({
      before: `Pour que ${articleTitle} s’intègre vraiment à toute la soirée, il est aussi utile de consulter la page `,
      linkLabel: serviceLabel,
      after: ' et de construire la musique, le timing, les animations et les transitions comme un seul déroulé.',
    }),
    whatsappText: (articleTitle: string) =>
      `Bonjour Elior, j’ai lu le guide "${articleTitle}" sur votre site et je voudrais un conseil pour la planification musicale de mon événement.`,
    trustTitle: 'Comment transformer cela en vrai plan d’événement',
    trustParagraphs: (articleTitle: string, serviceLabel: string, brandShort: string) => [
      `${articleTitle} n’est pas seulement une idée dans une liste. Dans un vrai événement, cela doit se connecter au public, au lieu, à la famille, au timing et au déroulé musical.`,
      `L’expérience de ${brandShort} aide à savoir où laisser place à l’émotion, où monter le rythme, et où une transition courte fonctionne mieux qu’un grand effet.`,
      `Avant l’événement, je comprends le public, les styles importants, les chansons à éviter et les moments qui doivent être précis. Le plan devient alors plus personnel et professionnel.`,
    ],
    workTitle: 'Ce que je vérifie avec vous avant de finaliser',
    workBullets: [
      'L’ordre de l’événement et les transitions entre accueil, cérémonie, repas et piste.',
      'Les chansons indispensables, les chansons à éviter et les styles préférés.',
      'L’adaptation au public : famille, amis, jeunes, adultes ou public professionnel.',
      'La coordination avec le lieu, les prestataires, les musiciens, les animations et le son.',
    ],
    carouselLabel: (title: string) => `${title} - guides`,
    guideTitle: 'Guide de planification d’événements',
    guideSubtitle: 'Tous les guides pour organiser mariages, hennés, bar/bat mitzvahs et événements privés ou professionnels.',
    relatedTitle: 'Autres guides utiles',
    faqTitle: 'Questions fréquentes',
    authorTitle: 'Écrit à partir d’une vraie expérience terrain',
    authorText: 'Ce guide s’appuie sur plus de 15 ans d’expérience dans les mariages, hennés, bar/bat mitzvahs et événements. L’objectif est de donner des conseils pratiques, pas des idées génériques.',
    sections: {
      חתונה: { title: 'Organisation de mariage', subtitle: 'Guides courts pour les moments musicaux clés, de la houppa au slow.', keys: ['wedding_chuppah_song', 'wedding_timeline', 'wedding_attractions', 'wedding_musicians', 'wedding_slow_song', 'wedding_music'] },
      חינה: { title: 'Organisation de henné', subtitle: 'Idées musicales pour une henné entre tradition, famille et énergie.', keys: ['henna_entrance', 'henna_timeline', 'henna_attractions', 'henna_musicians', 'henna_music', 'henna_moroccan', 'henna_kurdish', 'henna_tunisian', 'henna_yemenite', 'henna_indian', 'henna_iraqi', 'henna_persian'] },
      'בר-מצווה': { title: 'Organisation bar/bat mitzvah', subtitle: 'Guides pour entrées, chansons enregistrées et moments musicaux familiaux.', keys: ['bar_bat_entrance', 'bar_bat_timeline', 'bar_bat_attractions', 'bar_bat_musicians', 'bar_bat_recording', 'bar_bat_music'] },
      אירוע: { title: 'Organisation d’événement', subtitle: 'Outils simples pour planifier musique, timing et ambiance.', keys: ['event_entrance', 'event_music', 'event_music_timeline', 'event_attractions', 'event_musicians'] },
    },
    articles: {
      wedding_chuppah_song: { title: 'Choisir une chanson d’entrée à la houppa', sectionTitle: 'Comment choisir une chanson d’entrée à la houppa', description: 'Choisissez une chanson personnelle, émouvante et bien minutée pour la cérémonie.', imageAlt: 'Un couple entre à la houppa avec une musique émouvante', intro: 'Une bonne chanson doit correspondre à votre personnalité, au rythme de marche, au lieu et à l’émotion voulue.', bullets: ['Choisissez une chanson qui vous ressemble.', 'Vérifiez que l’introduction fonctionne.', 'Adaptez la durée à la distance.', 'Coordonnez le départ et la transition avec le DJ.'], cta: 'Envie d’une entrée précise et émouvante ? Planifions-la ensemble.' },
      wedding_timeline: { title: 'Planning du mariage', sectionTitle: 'Comment construire le planning musical du mariage', description: 'Un planning clair relie accueil, houppa, slow et piste sans chute d’énergie.', imageAlt: 'Planning musical de mariage', intro: 'Le planning donne une structure à la soirée et prépare chaque transition.', bullets: ['Fixez les temps clés.', 'Gardez des marges.', 'Marquez les moments forts.', 'Coordonnez les transitions avec le DJ.'], cta: 'Un bon planning garde le mariage fluide.' },
      wedding_attractions: { title: 'Animations de mariage', sectionTitle: 'Comment choisir les animations', description: 'Les animations doivent enrichir l’expérience sans voler la place à la piste.', imageAlt: 'Animations sur une piste de mariage', intro: 'Photobooth, effets et surprises fonctionnent mieux avec un bon timing.', bullets: ['Adaptez au public.', 'Ne bloquez pas la piste.', 'Coordonnez avec le DJ.', 'Préférez peu mais précis.'], cta: 'Les bonnes animations soutiennent la fête.' },
      wedding_musicians: { title: 'Musiciens pour mariage', sectionTitle: 'Quand ajouter des musiciens live', description: 'Les musiciens live ajoutent de l’émotion à l’accueil, la houppa ou la piste.', imageAlt: 'Musiciens live à un accueil de mariage', intro: 'Saxophone, violon ou percussion doivent être coordonnés avec le DJ.', bullets: ['Choisissez le bon moment.', 'Coordonnez les morceaux.', 'Vérifiez le son.', 'Gardez l’intervention précise.'], cta: 'Les bons musiciens rendent les moments clés vivants.' },
      wedding_slow_song: { title: 'Choisir une chanson de slow', sectionTitle: 'Comment choisir un slow de mariage', description: 'Un slow doit être intime, naturel et jamais forcé.', imageAlt: 'Piste de mariage pendant un slow', intro: 'Le slow est court, mais bien préparé il reste mémorable. La chanson doit vous correspondre.', bullets: ['Choisissez une chanson que vous aimez vraiment.', 'Évitez une chanson trop longue.', 'Décidez si famille et amis rejoignent la danse.', 'Demandez une version courte si besoin.'], cta: 'Choisissons ensemble la chanson et la structure.' },
      wedding_music: { title: 'Choisir la musique du mariage', sectionTitle: 'Comment choisir la musique d’un mariage', description: 'La musique du mariage doit relier le couple, les amis et les deux familles.', imageAlt: 'DJ planifiant la musique d’un mariage', intro: 'Un mariage contient accueil, houppa, slow, piste et after party. Commencez par le public : amis jeunes, famille plus âgée, invités religieux, mizrahi, israélien, latin, hip hop, nostalgie, trance, techno et groupes aimés.', bullets: ['Analysez les âges, familles et besoins religieux.', 'Listez artistes, groupes et styles aimés.', 'Gardez de la place pour lire la piste.', 'Construisez le passage vers l’énergie tardive.'], cta: 'Une bonne musique équilibre goût personnel et lecture professionnelle du public.' },
      henna_entrance: { title: 'Entrée de henné', sectionTitle: 'Comment planifier l’entrée de henné', description: 'L’entrée doit ouvrir la soirée avec couleur, famille et rythme.', imageAlt: 'Entrée festive de henné', intro: 'Planifiez qui entre, sur quelle chanson et comment passer à la cérémonie.', bullets: ['Choisissez une chanson liée à la tradition.', 'Fixez l’ordre d’entrée.', 'Ajoutez des tambours si utile.', 'Préparez la transition.'], cta: 'Une bonne entrée soulève la famille dès le début.' },
      henna_timeline: { title: 'Planning de henné', sectionTitle: 'Comment construire le planning d’une henné', description: 'Un bon planning relie entrée, cérémonie, tenues et danse.', imageAlt: 'Planning d’une henné', intro: 'La henné a beaucoup de moments familiaux, donc l’ordre doit rester clair.', bullets: ['Planifiez entrée et cérémonie.', 'Gardez du temps pour les bénédictions.', 'Décidez où accélérer.', 'Évitez trop d’arrêts.'], cta: 'Un planning précis garde tradition et énergie.' },
      henna_attractions: { title: 'Animations de henné', sectionTitle: 'Comment choisir les animations de henné', description: 'Les animations doivent renforcer la couleur et la tradition sans surcharge.', imageAlt: 'Animations colorées de henné', intro: 'Tenues, tambours et photo spots fonctionnent quand ils suivent le déroulé.', bullets: ['Adaptez à la tradition familiale.', 'Gardez de la place pour danser.', 'Fixez le bon moment.', 'Désignez un responsable.'], cta: 'Les bonnes animations ajoutent de la couleur sans arrêter la fête.' },
      henna_musicians: { title: 'Musiciens pour henné', sectionTitle: 'Ajouter des musiciens à une henné', description: 'Les musiciens ajoutent un rythme authentique à l’entrée et à la cérémonie.', imageAlt: 'Musiciens et tambours à une henné', intro: 'Tambours, chanteur ou instruments traditionnels doivent travailler avec le DJ.', bullets: ['Choisissez selon le style.', 'Coordonnez les rythmes.', 'Vérifiez le son.', 'Gardez l’équilibre avec la piste.'], cta: 'Les musiciens live donnent une chaleur familiale.' },
      henna_music: { title: 'Choisir la musique de henné', sectionTitle: 'Comment choisir la musique d’une henné', description: 'La musique de henné doit respecter la tradition et ouvrir une piste joyeuse.', imageAlt: 'Choisir la musique de henné', intro: 'Commencez par la tradition familiale : marocaine, yéménite, persane, irakienne, kurde, tunisienne, indienne ou mixte, puis reliez-la au mizrahi, israélien, latin, hip hop, nostalgie et dance actuelle.', bullets: ['Rassemblez les chansons familiales importantes.', 'Pensez aux jeunes, aux anciens et au public religieux.', 'Mélangez authenticité et énergie actuelle.', 'Planifiez le passage cérémonie-piste.'], cta: 'La henné doit sonner comme votre famille et soulever la salle.' },
      henna_moroccan: { title: 'Henné marocain', sectionTitle: 'Comment organiser une henné marocaine joyeuse', description: 'Une henné colorée entre tradition, rythme et piste de danse.', imageAlt: 'Piste joyeuse lors d’une henné marocaine', intro: 'La musique doit honorer la tradition tout en ouvrant une piste moderne et festive.', bullets: ['Planifiez les entrées et tenues.', 'Mélangez rythmes marocains et hits actuels.', 'Gardez de la place pour les chansons familiales.', 'Coordonnez les moments clés avec le DJ.'], cta: 'Créons une bande-son qui respecte la tradition et soulève la piste.' },
      henna_kurdish: { title: 'Henné kurde', sectionTitle: 'Planification musicale pour une henné kurde', description: 'Chaleur familiale, rythmes traditionnels et vraie fête.', imageAlt: 'Fête familiale sur une piste de henné kurde', intro: 'La famille doit se sentir chez elle, pendant que tous les invités peuvent rejoindre la piste.', bullets: ['Rassemblez les chansons traditionnelles importantes.', 'Construisez un déroulé clair.', 'Mélangez rondes et hits connus.', 'Gardez de la place pour les demandes familiales.'], cta: 'Planifions une musique fidèle à la tradition et pleine d’énergie.' },
      henna_tunisian: { title: 'Henné tunisien', sectionTitle: 'Construire une henné tunisienne au bon rythme', description: 'Cérémonie, famille et joie avec une musique qui porte la soirée.', imageAlt: 'Musique et danse lors d’une henné tunisienne', intro: 'Le meilleur résultat vient d’un passage naturel entre tradition et fête ouverte.', bullets: ['Préparez les chansons familiales indispensables.', 'Fixez les temps des bénédictions et entrées.', 'Mélangez rythmes tunisiens et chansons actuelles.', 'Gardez des transitions courtes.'], cta: 'Planifions ensemble les moments familiaux et la piste.' },
      henna_yemenite: { title: 'Henné yéménite', sectionTitle: 'Planifier une henné yéménite joyeuse', description: 'Laissez place à la tradition puis continuez vers une fête énergique.', imageAlt: 'Henné yéménite avec musique et danse', intro: 'Un bon plan passe de la tradition à une piste actuelle sans perdre le caractère.', bullets: ['Choisissez les chansons d’entrée et de cérémonie.', 'Décidez quand la fête commence.', 'Mélangez yéménite, mizrahi et hits actuels.', 'Vérifiez le son pour cérémonie et danse.'], cta: 'Authentique et énergique peuvent aller ensemble.' },
      henna_indian: { title: 'Henné indien', sectionTitle: 'Comment organiser une henné indienne colorée', description: 'La henné indienne réunit couleur, tenues, cérémonie familiale et musique joyeuse.', imageAlt: 'Henné indienne colorée avec musique et danse', intro: 'Un bon plan relie tradition, entrées, tenues et piste ouverte à tous les invités.', bullets: ['Choisissez les chansons d’entrée et de cérémonie.', 'Planifiez entrées, tenues et bénédictions.', 'Mélangez rythmes indiens, mizrahi, israéliens et hits actuels.', 'Préparez une transition claire vers la danse.'], cta: 'Créons une bande-son colorée, respectueuse et énergique.' },
      henna_iraqi: { title: 'Henné irakien', sectionTitle: 'Planification musicale pour une henné irakienne', description: 'La henné irakienne est chaleureuse, familiale et portée par des chansons qui relient les générations.', imageAlt: 'Henné irakienne avec famille et danse', intro: 'La musique doit laisser place aux chansons familiales, aux bénédictions et aux rondes, puis passer naturellement à la fête.', bullets: ['Rassemblez les chansons irakiennes et familiales importantes.', 'Fixez l’ordre entrée, cérémonie et rondes.', 'Mélangez irakien, mizrahi et musique actuelle.', 'Gardez une transition courte vers la piste.'], cta: 'Planifions l’équilibre entre tradition, famille et piste vivante.' },
      henna_persian: { title: 'Henné persan', sectionTitle: 'Construire une henné persane au bon rythme', description: 'La henné persane mêle élégance, cérémonie familiale et musique joyeuse.', imageAlt: 'Henné persane élégante avec musique et joie', intro: 'Avec le bon plan, la tradition persane garde sa place et la piste reste actuelle, joyeuse et ouverte.', bullets: ['Choisissez des chansons persanes importantes pour les entrées.', 'Planifiez la cérémonie sans longs arrêts.', 'Mélangez persan, mizrahi, israélien et hits internationaux.', 'Coordonnez les temps forts avec le DJ.'], cta: 'Rendons la soirée respectueuse, joyeuse et fluide.' },
      bar_bat_recording: { title: 'Enregistrer une chanson pour bar/bat mitzvah', sectionTitle: 'Enregistrer une chanson pour bar ou bat mitzvah', description: 'Une chanson enregistrée peut rendre une entrée, une vidéo ou un moment familial très émouvant.', imageAlt: 'Microphone et enregistrement pour bar ou bat mitzvah', intro: 'Cela fonctionne mieux avec un texte personnel et une idée simple.', bullets: ['Choisissez une bande-son adaptée.', 'Écrivez un texte court et personnel.', 'Gardez du temps pour répéter.', 'Coordonnez le moment de diffusion.'], cta: 'Rendons la chanson enregistrée propre et émouvante.' },
      bar_bat_entrance: { title: 'Entrée de bar/bat mitzvah', sectionTitle: 'Comment planifier une entrée de bar ou bat mitzvah', description: 'Donnez un moment central à l’enfant sans en faire trop.', imageAlt: 'Entrée émouvante de bar ou bat mitzvah', intro: 'L’entrée doit convenir à l’enfant : dramatique, légère, courte ou joyeuse.', bullets: ['Choisissez une chanson qu’il ou elle aime.', 'Décidez qui entre ensemble.', 'Gardez une entrée courte et claire.', 'Reliez-la au moment suivant.'], cta: 'Construisons une entrée exactement adaptée.' },
      bar_bat_timeline: { title: 'Planning bar/bat mitzvah', sectionTitle: 'Comment construire le planning', description: 'Le planning équilibre entrée, bénédictions, repas et piste.', imageAlt: 'Planning de bar ou bat mitzvah', intro: 'Il faut garder les jeunes engagés tout en incluant la famille.', bullets: ['Fixez entrée, vidéo et repas.', 'Ouvrez la piste assez tôt.', 'Coordonnez les jeux avec le DJ.', 'Évitez trop de discours.'], cta: 'Le bon planning garde l’énergie pour tous.' },
      bar_bat_attractions: { title: 'Animations bar/bat mitzvah', sectionTitle: 'Comment choisir les animations', description: 'Les animations doivent convenir à l’enfant, aux amis et à la famille.', imageAlt: 'Animations pour bar ou bat mitzvah', intro: 'Photos, danseurs et jeux fonctionnent quand ils sont liés à l’enfant.', bullets: ['Choisissez quelque chose qu’il aime.', 'Vérifiez l’âge du public.', 'Ne cassez pas la piste.', 'Préférez une idée forte.'], cta: 'La bonne animation rend l’événement personnel.' },
      bar_bat_musicians: { title: 'Musiciens bar/bat mitzvah', sectionTitle: 'Quand ajouter des musiciens', description: 'Les musiciens peuvent renforcer l’entrée, l’accueil ou un moment familial.', imageAlt: 'Musiciens à une bar ou bat mitzvah', intro: 'Un moment live court fonctionne mieux avec un public jeune.', bullets: ['Choisissez l’instrument selon l’ambiance.', 'Gardez le moment court.', 'Coordonnez le son avec le DJ.', 'Renforcez la fête sans la remplacer.'], cta: 'Un moment live ajoute de la célébration sans lourdeur.' },
      bar_bat_music: { title: 'Choisir la musique bar/bat mitzvah', sectionTitle: 'Comment choisir la musique d’une bar ou bat mitzvah', description: 'La musique doit parler aux ados, aux parents et à la famille plus âgée.', imageAlt: 'Choisir la musique pour bar ou bat mitzvah', intro: 'Il y a plusieurs publics : les amis veulent des hits, les parents veulent un événement respectueux, et la famille doit se sentir incluse. Mélangez pop, hip hop, mizrahi, latin, nostalgie, trance, techno et musique religieuse si besoin.', bullets: ['Demandez à l’enfant ses artistes et styles préférés.', 'Vérifiez ce que la famille aime.', 'Mélangez hits ados et moments familiaux.', 'Préparez une liste à éviter.'], cta: 'La bonne musique place l’enfant au centre tout en reliant la famille.' },
      event_music: { title: 'Choisir la musique d’un événement', sectionTitle: 'Comment choisir la musique d’un événement', description: 'La musique doit correspondre au public, au lieu et au but de la soirée.', imageAlt: 'DJ planifiant la musique d’un événement', intro: 'La musique d’un événement n’est pas seulement une playlist : c’est le public, le timing et l’énergie.', bullets: ['Définissez le public et l’ambiance.', 'Choisissez les chansons importantes.', 'Laissez de la place à la lecture du public.', 'Préparez une liste de titres à éviter.'], cta: 'Un bon plan musical transforme un fond sonore en soirée mémorable.' },
      event_entrance: { title: 'Entrée d’événement', sectionTitle: 'Comment planifier une entrée', description: 'Une entrée donne un départ clair et festif à la soirée.', imageAlt: 'Entrée festive d’événement', intro: 'Même un événement général gagne avec une entrée pensée.', bullets: ['Choisissez une chanson adaptée.', 'Décidez qui entre.', 'Coordonnez lumière et annonce.', 'Gardez l’entrée courte.'], cta: 'Une bonne entrée pose l’ambiance.' },
      event_attractions: { title: 'Animations d’événement', sectionTitle: 'Comment choisir les animations', description: 'Les animations doivent convenir au public, au lieu et à l’objectif.', imageAlt: 'Animations lors d’un événement privé ou professionnel', intro: 'Elles créent de l’intérêt et du souvenir quand elles suivent le programme.', bullets: ['Adaptez au public.', 'Vérifiez place et électricité.', 'Coordonnez avec le DJ.', 'Soutenez le déroulé.'], cta: 'Les bonnes animations ajoutent de la valeur.' },
      event_musicians: { title: 'Musiciens pour événement', sectionTitle: 'Ajouter des musiciens live', description: 'Les musiciens ajoutent de la présence à l’accueil ou à un temps fort.', imageAlt: 'Musiciens live avec DJ lors d’un événement', intro: 'Saxophone, violon ou percussion doivent soutenir le DJ.', bullets: ['Choisissez selon l’ambiance.', 'Coordonnez le répertoire.', 'Vérifiez le son.', 'Utilisez-les au meilleur moment.'], cta: 'Les musiciens live ajoutent une couche impressionnante.' },
      event_music_timeline: { title: 'Planifier le déroulé d’un événement', sectionTitle: 'Comment construire le déroulé d’un événement', description: 'Un déroulé clair aide la soirée à avancer entre accueil, discours, temps forts, repas et danse.', imageAlt: 'Planification du déroulé d’un événement', intro: 'Avec un déroulé clair, chaque prestataire sait quand intervenir et le DJ garde un rythme naturel.', bullets: ['Divisez l’événement en étapes.', 'Définissez les moments forts.', 'Gardez des marges pour les changements.', 'Coordonnez avec le lieu et les prestataires.'], cta: 'Construisons le déroulé selon le lieu, le public, les prestataires et le contenu.' },
    },
  },

  // ─────────────────────────────────────────────────────────────
  // MENU
  // ─────────────────────────────────────────────────────────────

  menu: {
    sections: [
      { id: 'home', label: 'Accueil' },
      { id: 'story', label: 'Mon histoire' },
      { id: 'gallery', label: 'Galerie' },
      { id: 'contact', label: 'Contact' },
      { id: 'info', label: 'Infos' },
      { id: 'reviews', label: 'Avis' },
      { id: 'planning', label: 'Planification' },
    ],
  },
  // ============================================================================
// French UI Copy — SEO FAQ + GEO (1:1 translation of en.ts)
// Texte uniquement — PAS de logique, PAS d’URLs, PAS de React
// ============================================================================
  seo: {
    faq: {
      wedding: [
        {
          q: `Que comprend un service de DJ pour mariage {city} ?`,
          a: `Le service comprend une consultation personnalisée, la création d’une bande-son sur mesure, un accompagnement professionnel tout au long du processus, une excellente lecture du public, des mix précis et une fusion des styles, avec une énergie qui garantit un mariage joyeux du premier au dernier moment.`,
        },
        {
          q: `Combien coûte un DJ pour mariage {city} ?`,
          a: `{city} Les prix varient généralement entre ₪4,000–₪9,000 selon la taille, la date et l’équipement.`,
        },
        {
          q: `Comment choisir un DJ pour mariage {city} ?`,
          a: `Il est important de choisir un DJ expérimenté avec une bonne lecture du public et une connexion avec le couple. Consultez les avis, regardez des vidéos réelles et assurez-vous qu’il comprend votre style.`,
        },
        {
          q: `Un DJ {city} fournit-il aussi l’éclairage ?`,
          a: `La plupart des salles incluent un éclairage de base. Un éclairage avancé peut être ajouté selon vos besoins.`,
        },
        {
          q: `Peut-on intégrer des musiciens live ?`,
          a: `Oui — saxophoniste, violoniste, percussionniste ou autres peuvent être intégrés.`,
        },
        {
          q: `Combien de temps joue un DJ lors d’un mariage ?`,
          a: `La durée varie selon le programme — de quelques heures à illimité.`,
        },
        {
          q: `Un DJ local {city} connaît-il les lieux ?`,
          a: `Oui, dans la plupart des cas, ce qui permet une coordination fluide et une meilleure qualité sonore.`,
        },
        {
          q: `Que comprend un forfait DJ mariage {city} ?`,
          a: `Équipement professionnel et prestation complète, avec options supplémentaires.`,
        },
        {
          q: `Y a-t-il du matériel de secours ?`,
          a: `Oui, toujours.`,
        },
        {
          q: `Comment choisir la musique de cérémonie ?`,
          a: `Choix personnalisé avec le couple pour créer un moment précis et émouvant.`,
        },
        {
          q: `Quand réserver un DJ mariage {city} ?`,
          a: `Au moins 6 mois à l’avance, voire un an en haute saison.`,
        },
        {
          q: `Peut-on choisir toute la playlist ?`,
          a: `Oui — totalement personnalisable.`,
        },
        {
          q: `Quelles sont les attractions populaires ?`,
          a: `Feux froids, fumée lourde, ballons, bulles, confettis et plus.`,
        },
      ],

      henna: [
        {
          q: `Que comprend un service DJ henné {city} ?`,
          a: `Consultation, bande-son personnalisée, accompagnement et énergie pour une fête réussie.`,
        },
        {
          q: `Quels types de henné existent ?`,
          a: `Marocain, yéménite, perse, tunisien et autres.`,
        },
        {
          q: `Comment organiser l’entrée ?`,
          a: `Planifiée à l’avance avec musique et timing précis.`,
        },
        {
          q: `Combien coûte un DJ henné {city} ?`,
          a: `₪2,500–₪5,000 selon les critères.`,
        },
        {
          q: `Comment choisir un DJ henné {city} ?`,
          a: `Expérience, lecture du public et adaptation aux traditions.`,
        },
        {
          q: `Durée de prestation ?`,
          a: `Flexible.`,
        },
        {
          q: `Attractions populaires ?`,
          a: `Feux froids, percussions, éclairage, etc.`,
        },
      ],

      bar_bat: [
        {
          q: `Que comprend un DJ Bar/Bat Mitsva {city} ?`,
          a: `Consultation, bande-son personnalisée, mix précis et énergie.`,
        },
        {
          q: `Combien coûte un DJ ?`,
          a: `₪2,500–₪4,500.`,
        },
        {
          q: `Comment choisir un DJ ?`,
          a: `Expérience avec jeunes publics.`,
        },
        {
          q: `Durée ?`,
          a: `Flexible.`,
        },
        {
          q: `Playlist ?`,
          a: `Personnalisée.`,
        },
      ],

      event: [
        {
          q: `Que comprend un DJ événement {city} ?`,
          a: `Consultation, musique personnalisée et énergie.`,
        },
        {
          q: `Combien coûte un DJ événement {city} ?`,
          a: `₪2,000–₪5,000.`,
        },
        {
          q: `Comment choisir ?`,
          a: `Expérience et avis.`,
        },
        {
          q: `Durée ?`,
          a: `Flexible.`,
        },
      ],

      homeEvent: [
        {
          q: `Que comprend un DJ événement ?`,
          a: `Consultation, musique et accompagnement.`,
        },
        {
          q: `Combien ça coûte ?`,
          a: `₪2,000–₪5,000.`,
        },
        {
          q: `Quels types d’événements ?`,
          a: `Mariages, hennés, événements privés et professionnels.`,
        },
        {
          q: `Matériel fourni ?`,
          a: `Oui.`,
        },
      ],
    },
  },

  // ─────────────────────────────────────────────────────────────
  // GEO
  // ─────────────────────────────────────────────────────────────

  geo: {
    regions: {
      דרום: 'Sud',
      מרכז: 'Centre',
    },

    cities: {
      'באר שבע': "Beer-Sheva",
      'אשקלון': 'Ashkelon',
      'אשדוד': 'Ashdod',
      'קריית גת': 'Kiryat Gat',
      'אופקים': 'Ofakim',
      'נתיבות': 'Netivot',
      'שדרות': 'Sderot',
      'להבים': 'Lehavim',
      'עומר': 'Omer',
      'דימונה': 'Dimona',
      'קריית מלאכי': 'Kiryat Malakhi',
      'ערד': 'Arad',
      'ירוחם': 'Yeruham',
      'מיתר': 'Meitar',
      'אילת': 'Eilat',
      'קריית עקרון': 'Kiryat Ekron',
      'גן יבנה': 'Gan Yavne',

      'תל אביב': 'Tel Aviv',
      'רמת גן': 'Ramat Gan',
      'גבעתיים': 'Givatayim',
      'ראשון לציון': 'Rishon LeZion',
      'חולון': 'Holon',
      'בת ים': 'Bat Yam',
      'רעננה': "Ra'anana",
      'הרצליה': 'Herzliya',
      'פתח תקווה': 'Petah Tikva',
      'יבנה': 'Yavne',
      'רחובות': 'Rehovot',
      'נס ציונה': 'Ness Ziona',
      'כפר סבא': 'Kfar Saba',
      'הוד השרון': 'Hod HaSharon',
      'מודיעין': "Modi'in",
      'ראש העין': "Rosh HaAyin",
      'נתניה': 'Netanya',
      'חדרה': 'Hadera',
      'עמק חפר': 'Vallée de Hefer',
    },

    globalLabel: 'Israël',
  },
} as const;

export type FrSeoGeoPack = typeof fr;
